var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogOut(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 6.04505C7 5.39218 6.28073 5.02046 5.80708 5.46977C4.07818 7.10983 3 9.42917 3 12.0003C3 16.9709 7.02944 21.0003 12 21.0003C16.9706 21.0003 21 16.9709 21 12.0003C21 9.42917 19.9218 7.10983 18.1929 5.46977C17.7193 5.02046 17 5.39218 17 6.04505C17 6.27731 17.1006 6.49689 17.266 6.65997C18.6451 8.02003 19.5 9.91034 19.5 12.0003C19.5 16.1425 16.1421 19.5003 12 19.5003C7.85786 19.5003 4.5 16.1425 4.5 12.0003C4.5 9.91034 5.35487 8.02003 6.734 6.65997C6.89938 6.49689 7 6.27731 7 6.04505Z",
    fill: "#2E2B63"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 3L12 12",
    stroke: "#2E2B63",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogOut);
export default __webpack_public_path__ + "static/media/logOut.b59840e513c930ab601a069ce5f476a6.svg";
export { ForwardRef as ReactComponent };